import type {
    GetAccountsForLead_lead_accounts as Accounts,
    GetContactsForLead_lead_contacts as Contacts,
} from 'nutshell-graphql-types';

import GET_ACCOUNTS_FOR_LEAD from './graphql/queries/get-accounts-for-lead.graphql';
import GET_CONTACTS_FOR_LEAD from './graphql/queries/get-contacts-for-lead.graphql';

export function getAccountsAndContactsCount(
    accounts?: Accounts | null,
    contacts?: Contacts | null
): number {
    let count = 0;

    if (accounts && accounts.edges) {
        count += accounts.edges.length;
        for (const account of accounts.edges) {
            if (account.leadAccountContacts) {
                count += account.leadAccountContacts.length;
            }
        }
    }

    if (contacts && contacts.nonCompanyMappedContacts) {
        count += contacts.nonCompanyMappedContacts.length;
    }

    return count;
}

export function refetchAccountsAndContactsQueries(variables: {leadId: string}): any[] {
    return [
        {query: GET_CONTACTS_FOR_LEAD, variables},
        {query: GET_ACCOUNTS_FOR_LEAD, variables},
    ];
}
